import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import queryString from 'query-string'
import axios from 'axios'
import DbConn from '~/Classes/siteVars.js'
import { loginAndGetToken } from '../../../data/actions/userActions'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import ReCaptcha from '../../../Common-Objects/Captcha'
import LandingPageTemplate from '../template'

export default function Soft2faAccept() {
    const dispatch = useDispatch()
    const user = useSelector((state) => state.user)
    const site = useSelector((state) => state.siteMaster)
    const [error, setError] = useState(false)
    const [captchaToken, setCapatchaToken] = useState('')
    const [confirmed, setConfirmed] = useState(false)

    const checkToken = async (token) => {
        try {
            const query = queryString.parse(location.search)
            const res = await axios.post(
                DbConn.getConnString() + '/soft2faconfirm',
                {
                    token,
                    captchaToken,
                    AccountMasterId: query.AccountMasterId || undefined
                },
                { withCredentials: true }
            )
            if (res.data.error) return setError('Invalid Link')
            dispatch(loginAndGetToken(null, null, res.data.token))
            if (res.data.AccountMaster) {
                dispatch({ type: 'LOGGEDIN_SUCCESS_ACCOUNTMASTER', payload: res.data })
            }
            setConfirmed(true)
        } catch (e) {
            setError('Invalid Link')
        }
    }

    useEffect(() => {
        if (!site?.siteId) return
        const query = queryString.parse(location.search)
        if (!query.token) return setError('Invalid Link')
        if (!captchaToken && site.siteId === 1) return
        checkToken(query.token)
    }, [captchaToken, site])

    useEffect(() => {
        // Wait until this one-time token has been exchanged. An existing customer
        // session in localStorage must not skip confirmlogin.
        if (!confirmed || !user.loggedIn) return
        const query = queryString.parse(location.search)
        let redirectUrl = query.redirect || '/cp'
        window.open(redirectUrl, '_self')
    }, [user, confirmed])

    return (
        <LandingPageTemplate
            header="We're validating your login"
            top={
                <div style={{ marginBottom: 8 }}>
                    <LoadingIcons />
                </div>
            }
            subheader={error || 'This should only take a moment...'}
        >
            {site.siteId === 1 && <ReCaptcha onComplete={(r) => setCapatchaToken(r)} />}
        </LandingPageTemplate>
    )
}
